import { ActionCreator, createAction, props, Action } from '@ngrx/store'

import { OfflineAction, QueuedOfflineAction } from '../reducers'

export enum OfflineActionTypes {
  ADD_ACTIONS = '[Offline] Add Offline Actions',
  ADD_ACTIONS_SUCCESS = '[Offline] Add Offline Actions Success',
  ADD_ACTIONS_FAILURE = '[Offline] Add Offline Actions Failure',
  SYNC_OFFLINE = '[Offline] Sync Offline Actions',
  SYNC_OFFLINE_SUCCESS = '[Offline] Sync Offline Actions Success',
  SYNC_OFFLINE_FAILURE = '[Offline] Sync Offline Actions Failure',
  CLEAR_ACTIONS = '[Offline] Clear Offline Actions',
}

export const addOfflineActions: ActionCreator<
  OfflineActionTypes.ADD_ACTIONS,
  (props: { action: OfflineAction; actionId?: number; actionVerb?: string }) => {
    action: OfflineAction
    actionId?: number
    actionVerb?: string
  } & Action<OfflineActionTypes.ADD_ACTIONS>
> = createAction(
  OfflineActionTypes.ADD_ACTIONS,
  props<{ action: OfflineAction; actionId?: number; actionVerb?: string }>(),
)
export const addOfflineActionsSuccess: ActionCreator<
  OfflineActionTypes.SYNC_OFFLINE_SUCCESS,
  (props: {
    payload: {
      action: OfflineAction
      message?: string
    }
  }) => {
    payload: {
      action: OfflineAction
      message?: string
    }
  } & Action<OfflineActionTypes.SYNC_OFFLINE_SUCCESS>
> = createAction(
  OfflineActionTypes.SYNC_OFFLINE_SUCCESS,
  props<{ payload: { action: OfflineAction; message?: string } }>(),
)

export const addOfflineActionsFailure: ActionCreator<
  OfflineActionTypes.SYNC_OFFLINE_FAILURE,
  (props: { error: unknown; message?: string }) => {
    error: unknown
    message?: string
  } & Action<OfflineActionTypes.SYNC_OFFLINE_FAILURE>
> = createAction(OfflineActionTypes.SYNC_OFFLINE_FAILURE, props<{ error: unknown; message?: string }>())

export const syncOfflineActions: ActionCreator<
  OfflineActionTypes.SYNC_OFFLINE,
  (props: { actions?: QueuedOfflineAction[] }) => {
    actions?: QueuedOfflineAction[]
  } & Action<OfflineActionTypes.SYNC_OFFLINE>
> = createAction(OfflineActionTypes.SYNC_OFFLINE, props<{ actions?: QueuedOfflineAction[] }>())
export const syncOfflineActionsSuccess: ActionCreator<
  OfflineActionTypes.SYNC_OFFLINE_SUCCESS,
  () => Action<OfflineActionTypes.SYNC_OFFLINE_SUCCESS>
> = createAction(OfflineActionTypes.SYNC_OFFLINE_SUCCESS)

export const syncOfflineActionsFailure: ActionCreator<
  OfflineActionTypes.SYNC_OFFLINE_FAILURE,
  (props: { error: unknown; message?: string }) => {
    error: unknown
    message?: string
  } & Action<OfflineActionTypes.SYNC_OFFLINE_FAILURE>
> = createAction(OfflineActionTypes.SYNC_OFFLINE_FAILURE, props<{ error: unknown; message?: string }>())

export const clearOfflineActions: ActionCreator<
  OfflineActionTypes.CLEAR_ACTIONS,
  () => Action<OfflineActionTypes.CLEAR_ACTIONS>
> = createAction(OfflineActionTypes.CLEAR_ACTIONS)
